import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/skeletons/GamesSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScContainer"] */ "/app/src/styles/common.ts");
